import React, {Component} from 'react'
import { NavLink } from 'react-router-dom'
import Router from './../../../services/Router'
import logo from './../../../static/logo-footer-institut.png'
import { fetchCounter } from './../../../services/ApiController'

import { appFooter } from './../../../styles'
export default class Footer extends Component {
  state = {
    counter: '00000',
    ready: false,
  }

  componentDidMount() {
    this.getDatas()
  }

  getDatas = () => {
    fetchCounter().then((data) => {
      let counter = data.counter

      if (counter.length < 5) {
        counter = `${new Array(5 - counter.length + 1).join('0')}${counter}`
      }
      this.setState({ counter: counter })
    }).catch((err) => {
      console.log('Something Wrong with counter', err)
    })
  }

  render () {
    const { counter } = this.state

    return (
      <footer className={`app-footer ${appFooter}`}>
        <div className="counter-wrap">
          <img className="counter-logo" src={logo} alt="Institut du Cerveau" />
          <span className="counter">
            {counter.split('').map((char, index) => (
              <span key={index}>{char}</span>
            ))}
          </span>
        </div>
        <ul className="reset">
          <li> <NavLink to={Router.contact.path}>Contact</NavLink> </li>
          <li> <NavLink to={Router.faqs.path}>Q&A</NavLink> </li>
          <li> <NavLink to={Router.legals.path}>Legal info</NavLink> </li>
          <li> <NavLink to={Router.privacy.path}>Privacy</NavLink> </li>
          <li> <NavLink to={Router.sitemap.path}>Sitemap</NavLink> </li>
        </ul>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Layout/BaseLayout/Footer.js